import React, { memo } from 'react';

import CdnImage, { cdnImageTypes } from '@prisjakt/ui-cdn-image';
import * as S from './styles';

export const { VARIANTS } = S;

type Props = {
  className?: string;
  name: string;
  storeId: number;
  featured?: boolean;
  hasImage: boolean;
  variant?: S.VARIANTS;
};

const StoreLogo = ({
  className,
  name,
  storeId,
  featured = false,
  hasImage,
  variant = S.VARIANTS.DEFAULT,
}: Props) => {
  const shouldRenderLogo =
    hasImage &&
    (featured ||
      variant === S.VARIANTS.CAMPAIGN ||
      variant === S.VARIANTS.SOTY);

  return (
    <S.StoreLogo
      showLogo={shouldRenderLogo}
      variant={variant}
      className={className}
    >
      {shouldRenderLogo ? (
        <CdnImage
          type={cdnImageTypes.store}
          name={storeId}
          width={S.variantToWidth[variant]}
          alt={name}
        />
      ) : (
        <S.StoreLogoText>{name}</S.StoreLogoText>
      )}
    </S.StoreLogo>
  );
};

export default memo(StoreLogo);
